import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
  Text,
  TableContainer,
  GridItem,
  Grid,
  InputGroup,
  InputLeftElement,
  Tooltip,
  Spinner,
} from "@chakra-ui/react";
import { useTable, useFilters, usePagination } from "react-table";
import axios from "axios";
import { SearchIcon } from "../../assets/svgs/Icons";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { toast, useToast } from "react-toastify";

function UserCreationTable() {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getUsers();
    ;
  }, []);

  const getUsers = async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}/api/user`;
      const token = localStorage.getItem("cu_user");

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === "success") {
        setUsers(response?.data?.data);
        setIsLoading(false);
      } else {
        ;
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleDelete = (userId) => {
    // Perform delete operation here
  };

  // const handleDelete = async (userId) => {
  //   try {
  //     const url = `${process.env.REACT_APP_API_HOST}/api/user/${userId}`;
  //     const token = localStorage.getItem("cu_user");

  //     const response = await axios.delete(url, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (response.data.status === "success") {
  //       // Perform any additional actions upon successful deletion
  //       toast.success("User deleted Successfully")
  //       ;
  //       // Refresh the user list by fetching the updated data
  //       getUsers();
  //     } else {
  //       ;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const data = useMemo(() => {
    if (searchQuery.trim() !== "") {
      return users.filter((user) =>
        user?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    } else {
      return users;
    }
  }, [users, searchQuery]);

  const columns = useMemo(
    () => [
      { Header: "Name", accessor: "name" },
      { Header: "Email", accessor: "email" },
      { Header: "Phone", accessor: "phone" },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ cell }) => {
          const roles = cell?.value;
          return (
            <Tooltip label={roles.join(", ")} placement="top-start">
              <Box
                maxWidth="200px"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {roles?.map((role, index) => (
                  <Text key={index} display="inline-block" mr={1}>
                    {role}
                  </Text>
                ))}
              </Box>
            </Tooltip>
          );
        },
      },
      // {
      //   Header: "Actions",
      //   Cell: ({ row }) => (
      //     <Button
      //       bg="#52BBFF"
      //       _hover={{ bg: "#52BBFF" }}
      //       color={"#ffffFF"}
      //       onClick={() => {
      //         handleDelete(row.original.id);
      //         ;
      //       }}
      //     >
      //       Update
      //     </Button>
      //   ),
      // },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize },
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters,
    usePagination
  );

  return (
    <Box mb="2rem">
      <Box mt="4rem">
        <Grid templateColumns="repeat(3,1fr)" gap={"2rem"}>
          <GridItem>
            <Box>
              {" "}
              <Text color={"#141D43"} fontSize="28px" fontWeight={"600"}>
                Users
              </Text>
              <Text color={" #3958DC"} fontSize="sm">
                All users that were added
              </Text>
            </Box>
          </GridItem>
          <GridItem>
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                children={<SearchIcon color="#B8DEF8" />}
              />
              <Input
                type="text"
                color={"#464C64"}
                bg={"#fff"}
                w={"300px"}
                h={"48px"}
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearch}
                fontSize={"14px"}
                borderRadius={"10px"}
                _placeholder={{
                  opacity: 1,
                  color: "#464C64",
                  fontSize: "14px",
                }}
              />
            </InputGroup>
          </GridItem>
          <GridItem>
            <Button
              onClick={() => navigate("/user-table/create")}
              bg="#52BBFF"
              color={"#fff"}
              _hover={{ bg: "#52BBFF" }}
            >
              Add User
            </Button>
          </GridItem>
        </Grid>
      </Box>

      <Box mt="2rem">
        <Text>
          Page{" "}
          <Text as="span" fontWeight="bold">
            {pageIndex + 1}
          </Text>{" "}
          of{" "}
          <Text as="span" fontWeight="bold">
            {Math.ceil(users?.length / pageSize)}
          </Text>
        </Text>
      </Box>

      <TableContainer
        mt="1rem"
        className="overflow-style"
        overflowX={"scroll"}
        bg={"#fff"}
        borderRadius={"15px"}
      >
        {isLoading ? (
          <Box alignItems="center" justifyContent="center" height="100vh">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.blue"
              size="xl"
            />
            <Text
              fontSize={"20px"}
              fontWeight={"800"}
              textAlign={"center"}
              mt="1rem"
            >
              Loading all users...
            </Text>
          </Box>
        ) : (
          <Table
            size="md"
            bg={"#fff"}
            borderRadius={"15px"}
            {...getTableProps()}
          >
            <Thead>
              {headerGroups?.map((headerGroup) => (
                <Tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <Th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>
            <Tbody {...getTableBodyProps()}>
              {page?.map((row) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()}>
                    {row?.cells?.map((cell) => (
                      <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                    ))}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </TableContainer>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop="1rem"
      >
        <Button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className="border rounded p-1"
          bg="#52BBFF"
          _hover={{ bg: "#52BBFF" }}
          mr={2}
        >
          <AiOutlineArrowLeft color="#141D43" size={18} />
        </Button>
        <Button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          className="border rounded p-1"
          bg="#52BBFF"
          _hover={{ bg: "#52BBFF" }}
          ml={2}
        >
          <AiOutlineArrowRight color="#141D43" size={18} />
        </Button>
      </Box>
    </Box>
  );
}

export default UserCreationTable;
